"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewApp = exports.TabSpinner = void 0;
var React = require("react");
var react_tabs_1 = require("react-tabs");
var components_1 = require("./components");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var simulationTab_1 = require("./simulationTab");
var typestyle_1 = require("typestyle");
var TabSpinner = function (props) {
    return (React.createElement("div", { className: "iconwrapper" },
        React.createElement("i", { className: (0, typestyle_1.classes)("fas fa-spinner fa-spin tabSpinner", props.className) })));
};
exports.TabSpinner = TabSpinner;
var OverviewApp = (function (_super) {
    __extends(OverviewApp, _super);
    function OverviewApp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            tabIndex: 0,
            templates: []
        };
        return _this;
    }
    OverviewApp.prototype.render = function () {
        var _this = this;
        switch (this.state.tabIndex) {
            case 1:
                $(".filter_number, .filter_template, .matrix_mode, .include_costs, .simulation_options").hide();
                $(".view_option, .filter_eval").show();
                break;
            case 2:
                $(".filter_template, .matrix_mode, .simulation_options").hide();
                $(".view_option, .filter_number, .filter_eval, .include_costs").show();
                break;
            case 5:
                $(".include_costs, .simulation_options").hide();
                $(".view_option, .filter_number, .filter_template, .filter_eval, .matrix_mode").show();
                break;
            case 6:
                $(".include_costs, .matrix_mode, .filter_number, .filter_template").hide();
                $(".view_option, .filter_eval, .simulation_options").show();
                break;
            default:
                $(".view_option").hide();
        }
        return (React.createElement(react_tabs_1.Tabs, { selectedIndex: this.state.tabIndex, onSelect: function (tabIndex) { _this.setState({ tabIndex: tabIndex }); jQuery("#overviewTabIndex").val(tabIndex); }, selectedTabClassName: "active" },
            React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs overviewTabs" },
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "#0" },
                        gettext("Status"),
                        App_1.store.overview.statusTab.isLoading && React.createElement(exports.TabSpinner, null))),
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "#0" },
                        gettext("Bar Plots"),
                        App_1.store.overview.barplotTab.isLoading && React.createElement(exports.TabSpinner, null))),
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "#0" },
                        gettext("Value at Risk"),
                        App_1.store.overview.valueatriskTab.isLoading && React.createElement(exports.TabSpinner, null))),
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "#0" },
                        gettext("Ownership Statistics"),
                        App_1.store.overview.ownershipTab.isLoading && React.createElement(exports.TabSpinner, null))),
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "#0" },
                        gettext("Categories & Tags"),
                        App_1.store.overview.tagsTab.isLoading && React.createElement(exports.TabSpinner, null))),
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link", href: "#0" },
                        gettext("Matrices"),
                        App_1.store.overview.matrixTab.isLoading && React.createElement(exports.TabSpinner, null))),
                this.props.hasSimulation &&
                    React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                        React.createElement("a", { className: "nav-link", href: "#0" },
                            gettext("Simulation"),
                            App_1.store.overview.simulationTab.isLoading && React.createElement(exports.TabSpinner, null)))),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(components_1.OverviewStatusListComponent, { statuses: App_1.store.overview.statusTab.statuses, todos: App_1.store.overview.statusTab.todos, isLoading: App_1.store.overview.statusTab.isLoading })),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(components_1.OverviewBarPlotListComponent, { eval_types: App_1.store.overview.viewOptions.eval_types, data: App_1.store.overview.barplotTab.data, isLoading: App_1.store.overview.barplotTab.isLoading })),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(components_1.OverviewValueAtRiskListComponent, { eval_types: App_1.store.overview.viewOptions.eval_types, number_to_show: App_1.store.overview.viewOptions.number_to_show, data: App_1.store.overview.valueatriskTab.data, isLoading: App_1.store.overview.valueatriskTab.isLoading, include_costs: App_1.store.overview.viewOptions.include_costs })),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(components_1.OverviewOwnershipListComponent, { data: App_1.store.overview.ownershipTab.data, isLoading: App_1.store.overview.ownershipTab.isLoading })),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(components_1.OverviewCategoriesAndTagsComponent, { data: App_1.store.overview.tagsTab.data, isLoading: App_1.store.overview.tagsTab.isLoading })),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement(components_1.OverviewMatrixComponent, { eval_types: App_1.store.overview.viewOptions.eval_types, selected_definitions: App_1.store.overview.viewOptions.selected_definitions, number_to_show: App_1.store.overview.viewOptions.number_to_show, data: App_1.store.overview.matrixTab.data, isLoading: App_1.store.overview.matrixTab.isLoading, useQuantitative: App_1.store.overview.viewOptions.show_quantitative })),
            this.props.hasSimulation &&
                React.createElement(react_tabs_1.TabPanel, null,
                    React.createElement(simulationTab_1.OverviewSimulationComponent, { isLoading: App_1.store.overview.simulationTab.isLoading, eval_types: App_1.store.overview.viewOptions.eval_types, data: App_1.store.overview.simulationTab.data, percentiles: App_1.store.overview.viewOptions.percentiles }))));
    };
    OverviewApp = __decorate([
        mobx_react_1.observer
    ], OverviewApp);
    return OverviewApp;
}(React.Component));
exports.OverviewApp = OverviewApp;
